import React from 'react'

export default function NoRealtimeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8872_25674)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.45605 2.73292C12.1911 4.34966 15.7336 10.1117 14.3571 15.5841C14.265 15.9442 14.333 16.3057 14.5159 16.6032C14.7134 16.9244 15.0466 17.1719 15.4616 17.2634C16.26 17.4413 17.061 16.9771 17.2498 16.2262C18.9863 9.34318 14.5261 2.08868 7.3103 0.0594122C6.52336 -0.162554 5.6948 0.256756 5.45969 0.995065C5.22333 1.73406 5.67057 2.51331 6.45605 2.73292Z"
          fill="#828282"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.8346 16.4583C9.01754 16.7559 9.31688 16.9919 9.69501 17.097C10.4819 17.319 11.3105 16.8997 11.5456 16.1614C12.3312 13.7061 12.0294 11.1619 10.6995 8.99881C9.36957 6.83568 7.17418 5.31812 4.51714 4.7294C3.7187 4.55145 2.91773 5.01562 2.72896 5.76659C2.53749 6.51588 3.03376 7.26855 3.83345 7.44582C5.68432 7.85764 7.20829 8.90484 8.12442 10.3949C9.04055 11.885 9.24429 13.648 8.69865 15.3592C8.57549 15.7424 8.63715 16.1372 8.8346 16.4583ZM1.73589 9.39227C0.927603 9.26374 0.15891 9.77497 0.0215127 10.5359C-0.107238 11.243 0.354508 11.9138 1.06987 12.1093L1.23931 12.1458C2.80325 12.3936 3.62065 13.7231 3.0672 15.1189C2.90652 15.5256 2.96006 15.9563 3.17421 16.3046C3.34118 16.5762 3.60568 16.7964 3.943 16.9143C4.71341 17.183 5.56921 16.8134 5.85483 16.0918C6.4449 14.5974 6.33627 13.071 5.54936 11.7911C4.76245 10.5111 3.40905 9.65957 1.73589 9.39227Z"
          fill="#828282"
        />
        <rect
          width="1.45073"
          height="21.8982"
          transform="matrix(0.707107 0.707107 -0.719314 0.694685 16.1855 1.60547)"
          fill="#828282"
        />
      </g>
      <defs>
        <clipPath id="clip0_8872_25674">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
